<template>
  <div
    id="toolbar-top-agency"
    v-if="
      quickBetEnabled === true &&
      (getUserType === '4' || getUserType === 4 || getCashier === true)
    "
  >
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <div class="tournament-card-header header-live market-view">
          <div class="tournament-card-header header-live market-view">
            <v-btn
              @click="homeHandlerAndResetState"
              small
              text
              v-if="
                this.getLiveMode == 'detail' || this.getLiveMode == 'printodds'
              "
            >
              {{ $t('prematch') }}
            </v-btn>
            <!--                        <v-btn @click="liveHandler" small text v-if="this.getLiveMode == 'preview' || this.getLiveMode == 'printodds'">-->
            <!--                            {{$t('live')}}-->
            <!--                        </v-btn>-->
            <v-btn @click="qBetHandler" small text>
              {{ $t('qBet') }}
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'ToolbarTopAgency',
  data() {
    return {
      selected: null,
    }
  },
  components: {},
  computed: {
    ...mapGetters({
      getEventsLiveDetail: 'odds/getEventsLiveDetail',
      getLiveMode: 'odds/getLiveMode',
      getCashier: 'user/getCashier',
      getUserType: 'user/getType',
      quickBetEnabled: 'settings/quickBetEnabled',
    }),
  },
  methods: {
    ...mapActions({
      setLiveMode: 'odds/setLiveMode',
      closePrematchEventsCards: 'odds/closePrematchEventsCards',
    }),

    homeHandler() {
      this.setLiveMode({ mode: 'preview' })
      this.selected = 'home'
    },

    homeHandlerAndResetState() {
      if (localStorage.getItem('event-detail')) {
        localStorage.removeItem('event-detail')
      }
      if (localStorage.getItem('preview-tournament-visited')) {
        localStorage.removeItem('preview-tournament-visited')
      }

      this.homeHandler()
      this.closePrematchEventsCards()
    },

    liveHandler() {
      this.setLiveMode({ mode: 'detail' })
      this.selected = 'live'
    },
    qBetHandler() {
      this.setLiveMode({ mode: 'qBet' })
      this.selected = 'qbet'
    },
  },
}
</script>
